export default "__VITE_ASSET__BbZK9SR2__"